module.exports = __webpack_public_path__ + "static/media/marshall-homepage-macbook-iphone-new-small-reduced.fe966a15.jp2";